import clsx from 'clsx'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Param, setArray, type SimplifiedCampaign, URLSearchParser } from 'shared/search-adapters'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import { AccountStatus } from './AccountStatus'
import { Answered } from './Answered'
import { Avatar } from './Avatar'
import { CampaignsSelect } from './CampaignsSelect'
import { Connection } from './Connection'
import css from './Filters.module.css'
import { Locations } from './Locations'
import { QualificationsSelector } from './QualificationsSelector'
import { StatusSelector } from './StatusSelector'
import { closeFilter } from './store'

export function Executions() {
	const [params, setParams] = useSearchParams()

	const [avatar, setAvatar] = useState(() => params.get(Param.Avatar) || '0'),
		[campaigns, setCampaigns] = useState<SimplifiedCampaign[]>(() => []),
		[distance, setDistance] = useState(() =>
			URLSearchParser.LinkedInCircle(params, Param.ExecutionDistance)
		),
		[locations, setLocations] = useState(() =>
			Locations.init(params, Param.ExecutionLocations)
		),
		[qualifications, setQualifications] =
			QualificationsSelector.useState(params),
		[statuses, setStatuses] = StatusSelector.useState(params)
	return (
		<form
			className={css.form}
			onReset={event => {
				const status = event.currentTarget.status as RadioNodeList
				status.value = '0'

				setStatuses([])
				setLocations([])
				setDistance([])
				setQualifications([])
				setAvatar('0')
				setCampaigns([])
			}}
			onSubmit={event => {
				event.preventDefault()
				event.stopPropagation()
				const status = event.currentTarget.status as RadioNodeList

				setParams(prev => {
					setArray(
						prev,
						Param.ExecutionDistance,
						distance.map(item => item.value)
					)

					if (status.value === '1') {
						params.set(Param.ExecutionPremium, '1')
					} else {
						params.delete(Param.ExecutionPremium)
					}

					Answered.parse(params, event.currentTarget)

					setArray(
						params,
						Param.ExecutionLocations,
						locations.map(Locations.parse)
					)

					prev.delete(Param.Skip)
					setArray(
						prev,
						Param.ExecutionStatus,
						statuses.map(item => item.value)
					)

					setArray(
						prev,
						Param.LinkedInQualification,
						qualifications.map(item => item.value)
					)

					const avatarRadio = event.currentTarget.avatar as RadioNodeList
					if (avatarRadio?.value && avatarRadio.value !== '0') {
						prev.set(Param.Avatar, avatarRadio.value)
					} else {
						prev.delete(Param.Avatar)
					}

					return prev
				})

				closeFilter()
			}}
		>
			<section className={css.section}>
				<h4 className={clsx(typo.subSection, css.title)}>Include</h4>

				<Connection setter={setDistance} value={distance} />
				<Locations locations={locations} setLocations={setLocations} />
				<Answered initial={URLSearchParser.Integer(params, Param.GotAnswer)} />
				<StatusSelector currents={statuses} setter={setStatuses} />
				<QualificationsSelector
					currents={qualifications}
					setter={setQualifications}
				/>
				<AccountStatus initial={Boolean(params.get(Param.ExecutionPremium))} />
				<Avatar initial={avatar} name="avatar" />
				<CampaignsSelect setter={setCampaigns} value={campaigns} />
				<div></div>
			</section>

			<div className={css.footer}>
				<Button type='reset' variant='secondary'>
					Clear all
				</Button>

				<Button type='submit'>Apply</Button>
			</div>
		</form>
	)
}
